



















































import Vue from 'vue';
import Component from 'vue-class-component';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import * as service from '@/services/clients';
import ClientForm from '@/components/clients/client-form.vue';
import BaseComponent from '@/components/base-component.vue';
import ListMessages from '@/components/UI/list-messages.vue';
import PermissionAuth from '@/components/UI/permission-auth.vue';
import UiToggleStatus from '@/components/UI/toggle-status.vue';
import UiCnpjFormat from '@/components/UI/cnpj-format.vue';
import { cloneDeep } from 'lodash';
import ClientModel from '@/models/client-model';
import { filterByText } from '@/helpers/filterByText';
import { resetModalScroll } from '@/helpers/resetModalScroll';

@Component({
  components: {
    PermissionAuth,
    ListMessages,
    ClientForm,
    UiToggleStatus,
    UiCnpjFormat,
  },
})
export default class Clients extends BaseComponent {
  public formIsEdit: boolean = false;
  public formOpen: boolean = false;
  public error: boolean = false;
  public loading: boolean = false;

  public filter: any = {
    term: '',
  };

  public form: any = {
    valid: false,
    rules: {
      cnpj: [(v) => !!v || 'Digite o CNPJ'],
      name: [(v) => !!v || 'Digite o nome'],
    },
  };

  public $refs!: {
    form: HTMLFormElement;
  };

  public headers: any = [
    { text: 'CNPJ', value: 'cnpj' },
    { text: 'Nome', value: 'nome' },
    { text: 'Nome Fantasia', value: 'nomeFantasia' },
    { text: 'Ações', value: 'actions', align: 'right', sortable: false },
  ];
  public data: ClientModel[] = [];
  public item: ClientModel = new ClientModel();

  public beforeMount(): void {
    this.load();
  }

  public onEditItem(item: ClientModel): void {
    this.loader.start('Carregando item...');
    service.getClient(item.id).subscribe(
      (data) => {
        this.item = new ClientModel(data);
        this.formOpen = true;
        this.formOpen = true;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao carregar o item', 'error');
      },
    );
  }

  public customFilter(items, search, filter): any[] {
    const searchLower = search.toString().toLowerCase();
    const searchCNPJ = search.toString().replaceAll(/[^0-9a-zA-Z]/g, '');
    return items.filter((row) => {
      const cnpj = row.cnpj.replaceAll(/[^0-9a-zA-Z]/g, '');
      return (
          filterByText({ cnpj }, ['cnpj'], searchCNPJ) ||
          filterByText(row, ['nome', 'nomeFantasia', 'cnpj'], searchLower)
      );
    });
  }

  public saveItem(item: ClientModel): void {
    this.closeForm();
    this.load();
  }

  public toggleItemStatus(item: ClientModel, status: boolean): void {
    this.loader.start('Atualizando registro...');
    const payload = item.toJson();
    payload.ativo = status;
    service.activateClient(payload.id, payload.ativo).subscribe(
      (data) => {
        item.ativo = status;
        this.loader.stop();
      },
      () => {
        this.loader.stop();
        this.toast.show('Ocorreu um erro ao atualizar o cliente', 'error');
      },
    );
  }

  public newItem(): void {
    this.item = new ClientModel();
    this.formIsEdit = false;
    this.formOpen = true;
  }

  public closeForm(): void {
    this.item = new ClientModel();
    this.formOpen = false;
    resetModalScroll();
  }

  private load(): void {
    this.data = [];
    this.loading = true;
    service.getClients().subscribe(
      (data) => {
        this.data = data.map((item) => new ClientModel(item));
        this.loading = false;
      },
      () => {
        this.loading = false;
        this.error = true;
      },
    );
  }
}
